// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2goLU","type":"styles_type__XOCeA","choices":"styles_choices__3dPdj"};